import { connect } from "react-redux";
import DonutList from "../../../../components/donutList/donutList";
import { actionCreators } from "../redux/sagas/attendance/attendance";
export default connect(
  state => ({
    donutValues: state.attendance.classByTypeAttendance.slice(0, 3).map(rev => ({
      ...rev,
      value: rev.percentage * 100,
      type: rev.name,
      fontSize: 24,
      hasMinusButton: true,
      attended: rev.totalAttendees,
      totalAttended: rev.totalPotentialAttendees,
      growth: rev.percentChange,
      toolTip: "Percentage change from previous month",
      centerToolTip: "Class Utilization",
      customTitleStyle: "title-height-60"
    })),
    groupValues: state.attendance.allClassesByType.map(({ name, id }) => ({
      label: name,
      value: id
    })),
    title: "Select Classes",
    module: ".widget-wrapper.attendanceWidget",
    selectHeight: 350,
    modalHeight: 450,
    modalWidth: 350,
    maxDonuts: 3,
    maxChecked: state.attendance.classByTypeAttendanceCheckedMax,
    modalPositionRight: true
  }),
  {
    onMinusButtonClick: actionCreators.removeClassCategory,
    itemWasChecked: items => {
      var keys = Object.keys(items);
      var filtered = keys.filter(function(key) {
        return items[key];
      });
      // console.log(filtered, filtered.length >= 3)
      const maxChecked = filtered.length >= 3 && true;
      return actionCreators.setClassTypesChecked({ filtered, maxChecked });
      // return actionCreators.setRevenueTypesCheckedMax(filtered.length >= 3 && true)
    },
    onSubmit: result => {
      const revenueTypeIds = Object.keys(result.checkedGroups);
      const revenueTypeName = result.groupName;
      return actionCreators.addClassChart({ revenueTypeIds, revenueTypeName });
    }
  }
)(DonutList);
